import { render, staticRenderFns } from "./luckdrawlist.vue?vue&type=template&id=04aa0e8d&scoped=true&"
import script from "./luckdrawlist.vue?vue&type=script&lang=js&"
export * from "./luckdrawlist.vue?vue&type=script&lang=js&"
import style0 from "./luckdrawlist.vue?vue&type=style&index=0&id=04aa0e8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aa0e8d",
  null
  
)

export default component.exports